import gql from 'graphql-tag'

import { fragments as NodeFragments } from 'components/Node'

const query = gql`
  query($path: String!) {
    route(path: $path) {
      ... on EntityCanonicalUrl {
        entity {
          entityId
          entityType

          ... on TaxonomyTermChannel {
            __typename
            name
            subtitle: fieldTeaserText

            presentationEnabled: fieldTrailPresentationEnabled

            presentation: fieldTrailPresentation {
              entity {
                ... on ParagraphTrailPresentation {
                  text: fieldText {
                    value
                    __typename
                  }
                  image: fieldImage {
                    entity {
                      image: thumbnail {
                        alt
                        title
                        derivative(style: TRAIL_PRESENTATION_IMAGE) {
                          url
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  title: fieldLabel
                  tags: fieldTags
                  node: fieldNodeReference {
                    entity {
                      ... on NodeArticle {
                        weight: draggableViewsWeight
                        nid
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }

            media: fieldTeaserMedia {
              entity {
                ... on MediaImage {
                  thumbnail {
                    targetId
                    alt
                    title
                    derivative(style: HERO_IMAGE) {
                      width
                      height
                      url
                    }
                  }
                }
              }
            }

            trailArticles {
              count

              nodes: entities {
                ... on NodeArticle {
                  ...NodeArticleFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${NodeFragments.article}
`

export default query
